const buildAdminAvatarSvg = () =>
  `<svg xmlns="http://www.w3.org/2000/svg" width="256" height="256" viewBox="0 0 256 256" fill="none">
    <defs>
      <linearGradient id="adminBg" x1="30" y1="20" x2="220" y2="236" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FDBA74"/>
        <stop offset="1" stop-color="#F97316"/>
      </linearGradient>
    </defs>
    <rect width="256" height="256" rx="128" fill="url(#adminBg)"/>
    <path d="M128 58L145 88H175L153 108L161 137L128 118L95 137L103 108L81 88H111L128 58Z" fill="#FFF7ED"/>
    <circle cx="128" cy="139" r="34" fill="#FFF7ED"/>
    <rect x="76" y="176" width="104" height="38" rx="19" fill="#FFF7ED"/>
  </svg>`

export const DEFAULT_ADMIN_AVATAR = `data:image/svg+xml;utf8,${encodeURIComponent(buildAdminAvatarSvg())}`

export const getEmployeeAvatar = (iconUrl?: string | null, isMaster?: boolean): string =>
  iconUrl && iconUrl.trim().length > 0 ? iconUrl : isMaster ? DEFAULT_ADMIN_AVATAR : ""
